import { createContext, useContext } from "react";

const BackgroundContext = createContext();

export function useBackground() {
  return useContext(BackgroundContext);
}

export default BackgroundContext;
